


// drawParcelBoundaries.js


/* global google */

let currentDrawnItems = [];

/**
 * Draws a parcel boundary and node markers on a Google Map.
 *
 * @param {google.maps.Map} map - The Google Map instance.
 * @param {Array} coordinates - GeoJSON polygon coordinates [[lng, lat], ...].
 * @returns {Object} - The created Google Maps overlays.
 */


export function drawParcelBoundaries(map, coordinates) {

    if (!Array.isArray(coordinates) || !coordinates.length) return null;

    const phBlue = getComputedStyle(document.documentElement)
        .getPropertyValue('--phblue')
        .trim();

    clearParcel();  // Clear any previous drawing.

    // If it's a GeoJSON Polygon, coordinates will be [[ [lng, lat], ... ]]
    const flatCoords = coordinates[0]; // Exterior ring

    // Convert to Google Maps LatLng objects
    const path = flatCoords.map(([lng, lat]) => new google.maps.LatLng(lat, lng));

    // Draw the polygon outline as a polyline
    const outline = new google.maps.Polyline({
        path,
        geodesic: true,
        strokeColor: phBlue,
        strokeOpacity: 1.0,
        strokeWeight: 4
    });

    outline.setMap(map);
    currentDrawnItems.push(outline);

    // Draw a circle on each vertex
    const nodes = flatCoords.map(([lng, lat]) => {

        const marker = new google.maps.Marker({

            position: { lat, lng },
            map,
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                scale: 5,
                fillColor: phBlue,
                fillOpacity: 1.0,
                strokeWeight: 0,
            }
        });

        currentDrawnItems.push(marker);

        return marker;
    });

    // Also draw a label showing the boundary lenghs at the midpoint of each segment.
    for (let i = 0; i < flatCoords.length - 1; i++) {
        
        const [lng1, lat1] = flatCoords[i];
        const [lng2, lat2] = flatCoords[i + 1];

        const p1 = new google.maps.LatLng(lat1, lng1);
        const p2 = new google.maps.LatLng(lat2, lng2);

        const midLat = (lat1 + lat2) / 2;
        const midLng = (lng1 + lng2) / 2;
        const mid = new google.maps.LatLng(midLat, midLng);

        const distance = google.maps.geometry.spherical.computeDistanceBetween(p1, p2);

        if (distance < 1) continue;  // Skip very short segments

        const formatted =
            distance >= 1000
                ? distance.toFixed(1)    // Show only 1 decimal place when >= 1 km
                : distance.toFixed(2);    // Show only 1 decimal place when < 1 km

        const pillHeight = 18;
        const pillWidth = 50;
        const fontSize = 11;
        const pillRadius = pillHeight / 2;

        const anchor = new google.maps.Point(pillWidth / 2, pillHeight / 2);
        const scaledSize = new google.maps.Size(pillWidth, pillHeight);

        const marker = new google.maps.Marker({
            position: mid,
            map,
            icon: {
                url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
                  <svg xmlns="http://www.w3.org/2000/svg" height="${pillHeight}" width="${pillWidth}">
                    <rect rx="${pillRadius}" ry="${pillRadius}" width="100%" height="100%" fill="${phBlue}" />
                    <text x="50%" y="${pillHeight / 2 - 0.5}" font-size="${fontSize}" font-weight="500" fill="white"
                          font-family="system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif"
                          text-anchor="middle" dominant-baseline="central">
                      ${formatted}
                    </text>
                  </svg>
                `),
                anchor,
                scaledSize
            }
        });

        currentDrawnItems.push(marker);
    }

    return { outline, nodes };
}


export function clearParcel() {
    currentDrawnItems.forEach(item => item.setMap(null));
    currentDrawnItems = [];
}



